import Vue from 'vue'

export default {
  state: {
    downloadedPages: [],
    selectedPage: null,
  },
  getters: {
    getDownloadedPages: state => state.downloadedPages,
    getSelectedPage: state => state.selectedPage,
  },
  actions: {
    downloadPages: ({commit}, payload) => {
      return Vue.axios.post('page/getAll', payload).then(response => {
        if(response.status == 200){
          commit('SET_DOWNLOADED_PAGES', response.data)
        }
        return response
      }).catch(err => {
        return err
      })
    },
    downloadPage: ({commit}, payload) => {
      return Vue.axios.post('page/get/'+payload.id).then(response => {
        if(response.status == 200){
          commit('SET_SELECTED_PAGE', response.data)
        }
        return response
      }).catch(err => {
        return err
      })
    },
    updateSelectedPage: ({commit}, payload) => {
      commit('SET_SELECTED_PAGE', payload)
    },
    createPage: (state ,payload) => {
      return Vue.axios.post('page/create', payload).then(response => {
        return response
      }).catch(err => {
        return err
      })
    },
    savePage: (state , payload) => {
      return Vue.axios.post('page/update/'+payload.page.id, payload.page).then(response => {
        return response
      }).catch(err => {
        return err
      })
    },
    deletePage: (state,pageId) => {
      return Vue.axios.post('page/delete/'+pageId).then(response => {
        return response
      }).catch(err => {
        return err
      })
    },
  },
  mutations: {
    SET_DOWNLOADED_PAGES: (state, payload) => {
      state.downloadedPages = payload
    },
    SET_SELECTED_PAGE: (state, page) => {
      state.selectedPage = page
    },
  },
}
